import { BASE_USER_URL, ROLES } from 'appConstants';
import Dashboard from 'pages/Dashboard';
import Notifications from 'pages/Notifications';
import Administrators from 'pages/Administrators';
import Students from 'pages/Students';
import Trainers from 'pages/Trainers';
import Tasks from 'pages/Tasks';
import MyCompliance from 'pages/MyCompliance';
import MyTrainingSessions from 'pages/MyTrainingSessions';
import ViewMyTrainingSession from 'pages/MyTrainingSessions/View';
import Profile from 'pages/Profile';
import Companies from 'pages/Companies';
import CreateCompany from 'pages/Companies/Create';
import EditCompany from 'pages/Companies/Edit';
import EditProvisionedModule from 'pages/Companies/Provisioned/EditModule';
import CreateProvisionedTrainingPart from 'pages/Companies/Provisioned/CreatePart';
import EditProvisionedTrainingPart from 'pages/Companies/Provisioned/EditPart';
import EditProvisionedRole from 'pages/Companies/Provisioned/EditRole';
import EditProvisionedRoleVersionRequirements from 'pages/Companies/Provisioned/EditRoleVersionRequirements';
import EditAdministrator from 'pages/Administrators/Edit';
import CreateAdministrator from 'pages/Administrators/Create';
import EditTrainer from 'pages/Trainers/Edit';
import CreateTrainer from 'pages/Trainers/Create';
import EditJobTask from 'pages/Tasks/Edit';
import JobTaskVersionRequirements from 'pages/Tasks/Edit/JobTaskVersionRequirements';
import CreateJobTask from 'pages/Tasks/Create';
import EditStudent from 'pages/Students/Edit';
import CreateStudent from 'pages/Students/Create';
import TrainerStudents from 'pages/TrainerStudents';
import MoodleSync from 'pages/MoodleSync';
import QuestionPoolUpgrade from 'pages/QuestionPoolUpgrade';
import Events from 'pages/Events';
import Jobs from 'pages/Jobs';
import TrainingModules from 'pages/TrainingModules';
import EditTrainingModule from 'pages/TrainingModules/Edit';
import CreateTrainingPart from 'pages/TrainingModules/Edit/CreateTrainingPart';
import EditTrainingPart from 'pages/TrainingModules/Edit/EditTrainingPart';
import LanguageManager from 'pages/LanguageManager';
import TrainingSessions from 'pages/TrainingSessions';
import CreateTrainingSession from 'pages/TrainingSessions/Create';
import EditTrainingSession from 'pages/TrainingSessions/Edit';
import TrainingSessionSchedule from 'pages/TrainingSessionSchedule';
import TrainingSessionStatistics from 'pages/TrainingSessionStatistics';
import StudentTrainingSessionStatistics from 'pages/StudentTrainingSessionStatistics';

const routes = {
  companies: {
    to: `${BASE_USER_URL}companies`,
    title: 'routes.companies',
    icon: 'flight',
    component: Companies,
    rotateIcon: true,
    children: [
      {
        to: '/edit/:companyId/provisioned/modules/:moduleId/parts/create/:trainingMethod',
        title: 'routes.createTrainingPart',
        component: CreateProvisionedTrainingPart,
      },
      {
        to: '/edit/:companyId/provisioned/modules/:moduleId/parts/edit/:trainingPartId/:trainingMethod',
        title: 'routes.editTrainingPart',
        component: EditProvisionedTrainingPart,
      },
      {
        to: '/edit/:companyId/provisioned/modules/:moduleId',
        title: 'routes.editTrainingModule',
        component: EditProvisionedModule,
      },
      {
        to: '/edit/:companyId/provisioned/roles/:roleId/versions/:versionId/requirements',
        title: 'routes.jobTaskVersionRequirements',
        component: EditProvisionedRoleVersionRequirements,
      },
      {
        to: '/edit/:companyId/provisioned/roles/:roleId',
        title: 'routes.editJobTask',
        component: EditProvisionedRole,
      },
      {
        to: '/edit/:id',
        title: 'routes.editCompany',
        component: EditCompany,
      },
      {
        to: '/create',
        title: 'routes.createCompany',
        component: CreateCompany,
      },
    ],
  },
  dashboard: {
    to: `${BASE_USER_URL}dashboard`,
    title: 'routes.dashboard',
    icon: 'dashboard',
    component: Dashboard,
  },
  myTrainingSessions: {
    to: `${BASE_USER_URL}my-training-sessions`,
    title: 'routes.myTrainingSessions',
    icon: 'event_available',
    component: MyTrainingSessions,
    isV2: true,
    children: [
      {
        to: '/view/:id',
        title: 'routes.viewTrainingSession',
        component: ViewMyTrainingSession,
      },
    ],
  },
  trainerStudents: {
    to: `${BASE_USER_URL}students`,
    title: 'routes.students',
    icon: 'accessibility_new',
    component: TrainerStudents,
  },
  notifications: {
    to: `${BASE_USER_URL}notifications`,
    title: 'routes.notifications',
    icon: 'notifications',
    component: Notifications,
    isV2: true,
  },
  trainingModules: {
    to: `${BASE_USER_URL}training-modules`,
    title: 'routes.trainingModules',
    icon: 'view_module',
    component: TrainingModules,
    isV2: true,
    children: [
      {
        to: '/edit/:id/training-parts/create/:trainingMethod',
        title: 'routes.createTrainingPart',
        component: CreateTrainingPart,
      },
      {
        to: '/edit/:id/training-parts/edit/:trainingPartId/:trainingMethod',
        title: 'routes.editTrainingPart',
        component: EditTrainingPart,
      },
      {
        to: '/edit/:id',
        title: 'routes.editTrainingModule',
        component: EditTrainingModule,
      },
    ],
  },
  events: {
    to: `${BASE_USER_URL}events`,
    title: 'routes.events',
    icon: 'history',
    component: Events,
    isV2: true,
  },
  administrators: {
    to: `${BASE_USER_URL}administrators`,
    title: 'routes.administrators',
    icon: 'supervisor_account',
    component: Administrators,
    children: [
      {
        to: '/edit/:id',
        title: 'routes.editAdmin',
        component: EditAdministrator,
      },
      {
        to: '/create',
        title: 'routes.createAdmin',
        component: CreateAdministrator,
      },
    ],
  },
  students: {
    to: `${BASE_USER_URL}students`,
    title: 'routes.students',
    icon: 'accessibility_new',
    component: Students,
    children: [
      {
        to: '/edit/:id',
        title: 'routes.editStudent',
        component: EditStudent,
      },
      {
        to: '/create',
        title: 'routes.createStudent',
        component: CreateStudent,
      },
    ],
  },
  trainers: {
    to: `${BASE_USER_URL}trainers`,
    title: 'routes.trainers',
    icon: 'assignment',
    component: Trainers,
    children: [
      {
        to: '/edit/:id',
        title: 'routes.editTrainer',
        component: EditTrainer,
      },
      {
        to: '/create',
        title: 'routes.createTrainer',
        component: CreateTrainer,
      },
    ],
  },
  tasks: {
    to: `${BASE_USER_URL}tasks`,
    title: 'routes.jobTasks',
    icon: 'work',
    component: Tasks,
    isV2: true,
    children: [
      {
        to: '/edit/:jobTaskId/versions/:versionId/requirements',
        title: 'routes.jobTaskVersionRequirements',
        component: JobTaskVersionRequirements,
      },
      {
        to: '/edit/:id',
        title: 'routes.editJobTask',
        component: EditJobTask,
      },
      {
        to: '/create',
        title: 'routes.createJobTask',
        component: CreateJobTask,
      },
    ],
  },
  trainingSessions: {
    to: `${BASE_USER_URL}training-sessions`,
    title: 'routes.trainingSessions',
    icon: 'event_available',
    component: TrainingSessions,
    isV2: true,
    children: [
      {
        to: '/edit/:id',
        title: 'routes.editTrainingSession',
        component: EditTrainingSession,
      },
      {
        to: '/create',
        title: 'routes.createTrainingSession',
        component: CreateTrainingSession,
      },
    ],
  },
  trainingSessionSchedule: {
    to: `${BASE_USER_URL}training-sessions-schedule`,
    title: 'routes.trainingSessionSchedule',
    icon: 'calendar_today',
    component: TrainingSessionSchedule,
    isV2: true,
  },
  trainingSessionStatistics: {
    to: `${BASE_USER_URL}training-modules-statistics`,
    title: 'routes.trainingSessionStatistics',
    icon: 'analytics',
    component: TrainingSessionStatistics,
    isV2: true,
  },
  studentTrainingSessionStatistics: {
    to: `${BASE_USER_URL}training-modules-statistics`,
    title: 'routes.trainingSessionStatistics',
    icon: 'analytics',
    component: StudentTrainingSessionStatistics,
    isV2: true,
  },
  myCompliance: {
    to: `${BASE_USER_URL}my-compliance`,
    title: 'routes.myCompliance',
    icon: 'verified_user',
    component: MyCompliance,
    isV2: true,
  },
  profile: {
    to: `${BASE_USER_URL}profile`,
    title: 'routes.profile',
    icon: 'settings',
    component: Profile,
  },
  moodleSync: {
    to: `${BASE_USER_URL}moodle-sync`,
    title: 'routes.moodleSync',
    icon: 'sync',
    component: MoodleSync,
  },
  // TEMP: Question Pool Upgrade — remove after full migration.
  questionPoolUpgrade: {
    to: `${BASE_USER_URL}question-pool-upgrade`,
    title: 'routes.questionPoolUpgrade',
    icon: 'playlist_add_check',
    component: QuestionPoolUpgrade,
  },
  jobs: {
    to: `${BASE_USER_URL}jobs`,
    title: 'routes.jobs',
    icon: 'assignment',
    component: Jobs,
  },
  languageManager: {
    to: `${BASE_USER_URL}language-manager`,
    title: 'routes.languageManager',
    icon: 'language',
    component: LanguageManager,
  },
};

export const routesMapToRoles = {
  [ROLES.HYPER]: [
    routes.companies,
    routes.events,
    routes.notifications,
    routes.trainingModules,
    routes.tasks,
    routes.languageManager,
    routes.moodleSync,
    routes.jobs,
    routes.questionPoolUpgrade,
    routes.profile,
  ],
  [ROLES.SUPER]: [
    routes.dashboard,
    routes.notifications,
    routes.events,
    routes.administrators,
    routes.trainers,
    routes.students,
    routes.trainingModules,
    routes.tasks,
    routes.trainingSessions,
    routes.trainingSessionStatistics,
    routes.trainingSessionSchedule,
    routes.profile,
  ],
  [ROLES.ADMIN]: [
    routes.dashboard,
    routes.notifications,
    routes.trainers,
    routes.students,
    routes.trainingSessions,
    routes.trainingSessionStatistics,
    routes.trainingSessionSchedule,
    routes.profile,
  ],
  [ROLES.TRAINER]: [
    routes.myTrainingSessions,
    routes.notifications,
    routes.trainerStudents,
    routes.trainingSessionStatistics,
    routes.trainingSessionSchedule,
    routes.profile,
  ],
  [ROLES.USER]: [
    routes.myTrainingSessions,
    routes.notifications,
    routes.myCompliance,
    routes.studentTrainingSessionStatistics,
    routes.trainingSessionSchedule,
    routes.profile,
  ],
};
export default routes;
